import {v4 as uuidv4} from 'uuid'
import {useCallback, useEffect, useRef, useState} from 'react'

/**
 * Hook for managing idempotency keys
 * Generates a new UUID idempotency key when the modal/component/form opens
 * @param {boolean} newForm - Whether the component/modal/form is open or viewed (triggers key regeneration when it opens)
 * @returns {Object} Object containing the current idempotency key and a function to manually regenerate it
 */
export default function useIdempotencyKey(newForm = false) {
  const [idempotencyKey, setIdempotencyKey] = useState(() => uuidv4())
  const previousIsOpen = useRef(newForm)

  const regenerate = useCallback(() => {
    setIdempotencyKey(uuidv4())
  }, [])

  useEffect(() => {
    if (newForm && !previousIsOpen.current) {
      setIdempotencyKey(uuidv4())
    }
    previousIsOpen.current = newForm
  }, [newForm])

  return {idempotencyKey, regenerate}
}
